import { render } from "./GroupAccessManagementAggregate.vue?vue&type=template&id=3d80b06c"
import script from "./js/groupAccessManagementAggregate.js?vue&type=script&lang=js&external"
export * from "./js/groupAccessManagementAggregate.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__